import BillingSummaryCSVPreviewColumnsStrategy from './BillingSummaryCSVPreviewColumnsStrategy'

export default function BillingSummaryCSVPreviewTimeOnBillableTasksStrategy() {}

BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.prototype = new BillingSummaryCSVPreviewColumnsStrategy();

BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.prototype.init = function ()
{
    BillingSummaryCSVPreviewColumnsStrategy.prototype.init.call( this );
    return this;
};

BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.prototype.getNumOfDataColumns = function ()
{
    return 4;
};

BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.prototype.addMainHeaderRowCells = function ( mainHeaderRow )
{
    this.addCell( mainHeaderRow, this.message("report.billing_summary.overall_spent.only_billible.csv") );

    this.addBillingTypeCells( mainHeaderRow, this.getNumOfDataColumns() - 1 );
};

BillingSummaryCSVPreviewColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function ( colGroupingRow )
{
    // do nothing
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewTimeOnBillableTasksStrategy.js